document.addEventListener("DOMContentLoaded", function () {
  if (window.__omnichat_pixel_loaded) {
    return;
  }

  function omniATCSingle(eventName = 'add_to_cart', data) {
    if (!window.omnichatTracker) {
      console.log('omnichatTracker not exists')
      return;
    }

    if (! data.id) {
      return;
    }

    window.omnichatTracker.push([
      "event",
      eventName,
      {
        items: [
          {
            id: data.id,
            name: data.name,
            type: data.type,
            vendor: data.vendor,
            variant: data.variant,
            quantity: data.quantity,
            price: data.price,
          },
        ],
      },
    ]);
    console.log(eventName, data)
  }
  const quickAddBtns = document.querySelectorAll(".productitem--action button");
  if (quickAddBtns) {
    Array.from(quickAddBtns).forEach((button) => {
      button.addEventListener("click", (e) => {
        const { target } = e;
        const { dataset } = target;
        if (target && dataset) {
          omniATCSingle('add_to_cart', {
            id: dataset.productId,
            name: dataset.productName,
            type: dataset.productType,
            vendor: dataset.productVendor,
            variant: dataset.productVariant,
            quantity: dataset.productQuantity,
            price: dataset.productPrice,
          });
        }
      });
    });
  }

  const staticATCBtns = document.querySelectorAll("[data-product-atc]");
  if (staticATCBtns) {
    Array.from(staticATCBtns).forEach((button) => {
      button.addEventListener("click", (e) => {
        const { target } = e;

        const { dataset } = target;

        if (!target || !dataset) {
          return;
        }

        const form = target.closest("form");
        if (!form) {
          return;
        }

        const quantityEl = form.querySelector('[name="quantity"]');
        const variantEl = form.querySelector("select");
        const priceEl = form.querySelector("[data-price ] > [data-currency]");

        omniATCSingle('add_to_cart', {
          id: dataset.productId,
          name: dataset.productName,
          type: dataset.productType,
          vendor: dataset.productVendor,
          variant: variantEl ? variantEl.value : '',
          quantity: quantityEl ? quantityEl.value : '0',
          price: dataset.productPrice,
        });
      });
    });
  }

  const removeFromCartBtns = document.querySelectorAll('.cart-item--remove');
  if (removeFromCartBtns.length) {
    Array.from(removeFromCartBtns).forEach(anchor => {
      anchor.addEventListener('click', (e) => {
        let { target } = e;

        if (! (target instanceof HTMLAnchorElement)) {
          target = target.closest('a');
        }

        if (!target) {
          return;
        }

        const { dataset } = target;
        
        if (!dataset) {
          return;
        }

        console.log(dataset);

        omniATCSingle('remove_from_cart', {
          id: dataset.productId,
          name: dataset.productName,
          type: dataset.productType,
          vendor: dataset.productVendor,
          variant: dataset.productVariant,
          quantity: dataset.productQuantity,
          price: dataset.productPrice,
        });
      }); 
    });
  }

  const checkoutBtns = document.querySelectorAll('button[name="checkout"]');
  const cart_items = document.querySelector('#cart_items');
  if (checkoutBtns.length && cart_items) {
    try {
      Array.from(checkoutBtns).forEach(el => {
        const items = JSON.parse(cart_items.textContent);
        const addItems = items.map(item => ({
          id: item.product_id,
          variant: item.variant_title,
          quantity: item.quantity,
          title: item.product_title,
          type: item.product_type,
          vendor: item.vendor,
        }));

        window.omnichatTracker.push([
          "event",
          'checkout',
          {
            items: addItems
          },
        ]);

        console.log(
          'checkout',
          addItems
        )
      });
    } catch (e) {
      console.error(e);
    }
  }

  window.__omnichat_pixel_loaded = true;
});
